import axios from 'axios';
import { getCookie, setCookie, deleteCookie } from './cookies';

const api = axios.create({
  baseURL: '/',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor: Attach Access Token
api.interceptors.request.use(
  (config) => {
    const token = getCookie('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor: Handle 401 and Refresh Token
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If the error is 401 and we haven't tried refreshing yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = getCookie('refreshToken');

      if (refreshToken) {
        try {
          // Use full URL or ensure your proxy is configured to handle /apis
          const response = await axios.post('https://pranaamhospitals.com/apis/web/refreshToken', { refreshToken });

          if (response.data.accessToken) {
            const newAccessToken = response.data.accessToken;
            const newRefreshToken = response.data.refreshToken;

            // Update cookies
            setCookie('accessToken', newAccessToken, 1); // 1 day
            if (newRefreshToken) setCookie('refreshToken', newRefreshToken, 7);

            // Update header and retry original request
            originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
            return api(originalRequest);
          }
        } catch (refreshError) {
          // If refresh fails, clear user data and redirect to login
          deleteCookie('accessToken');
          deleteCookie('refreshToken');
          deleteCookie('user');
          window.location.href = '/login'; // Or your preferred login route
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;